export default __webpack_public_path__ + "static/media/heresWhatYouDo.7617bd11.png";